import React from 'react'
import PropTypes from 'prop-types'

import { graphql, compose, withApollo } from 'react-apollo'

import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'

import { withRouter } from 'react-router-dom'
import { withFormik } from 'formik'
import * as yup from 'yup'
import { withSnackbar } from 'notistack'

import { styles } from './styles'
import { LOGIN_WITH_CIRCULAR_ID } from '../../graphql/mutations'
import { isMobile } from '../../utils'
import Version from '../../components/Version'

const logo = require('../../assets/images/g2g.png')

const validationSchema = () => {
  /* istanbul ignore next */
  return yup.object().shape({
    binId: yup.string().required('จำเป็นต้องระบุ'),
    password: yup.string().required('จำเป็นต้องระบุ')
  })
}

export const handleSubmit = async (values, { props, setSubmitting }) => {
  const { binId, password } = values
  const { history, LoginWithCircularId, client, enqueueSnackbar } = props
  let result

  setSubmitting(true)

  try {
    result = await LoginWithCircularId({
      variables: { binId, password }
    })
  } catch (error) {
    enqueueSnackbar(error.message)
  }

  if (result) {
    localStorage.setItem('user-token', result.data.login.token)
    client.resetStore()

    if (result.data.login.user.status === 'REGISTERED') {
      history.replace('/signup-bin')
    } else {
      history.replace('/')
    }
  }

  setSubmitting(false)
}

export const BinLogin = ({
  handleSubmit,
  handleChange,
  handleBlur,
  touched,
  errors,
  isSubmitting,
  history
}) => {
  return (
    <React.Fragment>
      <AppBar position="absolute">
        <Toolbar>
          <IconButton
            id="btnBack"
            color="inherit"
            aria-label="Menu"
            style={styles.menuButton}
            onClick={() => history.goBack()}>
            <BackIcon />
          </IconButton>
          <Typography
            id="titlePage"
            variant="h6"
            color="inherit"
            style={styles.grow}>
            Circular Bin Login
          </Typography>
        </Toolbar>
      </AppBar>
      <main style={styles.main}>
        <Paper elevation={isMobile ? 0 : 1} square style={styles.paper}>
          <Avatar src={logo} style={styles.avatar} />

          <Typography id="titlePage" variant="h5">
            Green2Get
          </Typography>

          <form onSubmit={handleSubmit}>
            <FormControl
              margin="normal"
              fullWidth
              error={touched.binId && Boolean(errors.binId)}>
              <TextField
                id="inputEmail"
                type="text"
                name="binId"
                label="หมายเลข Circular Bin (Circular Bin ID)"
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.binId && Boolean(errors.binId)}
              />
              {touched.binId && errors.binId && (
                <FormHelperText>{errors.binId}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              margin="normal"
              fullWidth
              error={touched.password && Boolean(errors.password)}>
              <TextField
                id="inputPassword"
                type="password"
                name="password"
                label="รหัสผ่าน (Password)"
                onChange={handleChange}
                onBlur={handleBlur}
                error={touched.password && Boolean(errors.password)}
              />
              {touched.password && errors.password && (
                <FormHelperText>{errors.password}</FormHelperText>
              )}
            </FormControl>
            {isSubmitting ? (
              <Button disabled fullWidth style={styles.button}>
                Signing In...
              </Button>
            ) : (
              <Button
                id="btnBinLogin"
                variant="contained"
                type="submit"
                color="primary"
                style={styles.button}
                fullWidth>
                Sign In
              </Button>
            )}
          </form>
        </Paper>
        <Version color="grey" />
      </main>
    </React.Fragment>
  )
}

BinLogin.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired
}

export default compose(
  withRouter,
  withSnackbar,
  withApollo,
  graphql(LOGIN_WITH_CIRCULAR_ID, { name: 'LoginWithCircularId' }),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: () => {
      return {
        binId: '',
        password: ''
      }
    },
    handleSubmit,
    validationSchema,
    displayName: 'BinLoginForm'
  })
)(BinLogin)



// WEBPACK FOOTER //
// ./src/pages/BinLogin/index.js